import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from 'eas-core-lib';
import { EntitlementRequest } from 'src/app/modules/user-profile/models/entitlement-request';
import { RoleGroupEntitlementRequest } from 'src/app/modules/user-profile/models/role-group-entitlement-request';

@Injectable({
  providedIn: 'root',
})
export class ArmDatService {
  private http = inject(HttpService);

  apiUrl() {
    return environment.armApiEndpoint;
  }

  organizatationRoles$() {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/OrganizationsRoles`
    );
  }

  SystemApplicationsByOrg$(orgkey) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/SystemApplications/${orgkey}`
    );
  }

  entitelmentGroups$(entitlementRequest: EntitlementRequest) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/entitlementGroups/${
        entitlementRequest.orgKey
      }/${entitlementRequest.sysKey}/${entitlementRequest.appKey}`
    );
  }

  roleGroupEntitelmentGroups$(
    roleGroupEntitlementRequest: RoleGroupEntitlementRequest
  ) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/roleGroupEntitlementGroups/${
        roleGroupEntitlementRequest.orgKey
      }/${roleGroupEntitlementRequest.appKey}/${
        roleGroupEntitlementRequest.roleType
      }`
    );
  }

  orgSystemApplications$(selectedOrganization: string) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/systemApplications/${selectedOrganization}`
    );
  }

  organizatationRolesByKey$(key) {
    let httpHeaders = new HttpHeaders().set('orgKey', key);
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/OrganizationsRoles/${key}`,
      { headers: httpHeaders }
    );
  }
  entitlementGroups$(orgKey, systemKey, applicationKey) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/entitlementGroups/${orgKey}/${systemKey}/${applicationKey}`
    );
  }

  getEntitlements$(orgKey, appkey, applicationKey) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/entitlements/${orgKey}/${appkey}/${applicationKey}`
    );
  }

  roleGroupEntitlements$(orgKey, applicationKey, roleType) {
    return this.http.get(
      `${this.apiUrl()}/api/v1/UserProfile/roleGroupEntitlements/${orgKey}/${applicationKey}/${roleType}`
    );
  }
}
